import React from 'react';
import { useTokenRefresh } from '../../hooks/useTokenRefresh';

/**
 * Composant wrapper qui active la surveillance automatique du token
 * Doit être utilisé à l'intérieur d'un AuthProvider
 */
export const TokenRefreshWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Active la surveillance automatique du token
  useTokenRefresh();
  
  return <>{children}</>;
};
